import React from 'react';

const PrivacyPolicy = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-toon-yellow p-4">
      <div className="text-center mb-6">
        <img 
          src="/assets/Toon_House_Logo.svg" 
          alt="Toon House Logo" 
          className="h-24 mx-auto mb-2"
        />
      </div>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-white shadow-lg rounded-lg p-6 md:p-8">
        <h1 className="text-3xl font-bold mb-6 text-center text-gray-800">Privacy Policy</h1>
        
        <div className="prose max-w-none text-gray-700 prose-headings:text-gray-800 prose-strong:text-gray-800">
          <p className="mb-4">
            Last Updated: July 24, 2025
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">1. Introduction</h2>
          <p>
            Toon House ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy 
            explains how we collect, use, disclose, and safeguard your information when you use our platform.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">2. Information We Collect</h2>
          <p>
            <strong>2.1. Personal Information:</strong><br />
            We may collect personal information that you voluntarily provide to us, including:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>First and last name</li>
            <li>Email address</li>
            <li>Voting preferences</li>
          </ul>
          
          <p>
            <strong>2.2. Automatically Collected Information:</strong><br />
            When you access our platform, we may automatically collect certain information, including:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>IP address</li>
            <li>Browser type</li>
            <li>Device information</li>
            <li>Usage patterns and preferences</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">3. How We Use Your Information</h2>
          <p>
            We may use the information we collect for various purposes, including:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Processing and recording your votes</li>
            <li>Communicating with you about the voting process</li>
            <li>Improving our platform and user experience</li>
            <li>Preventing fraudulent votes and ensuring the integrity of our contests</li>
            <li>Complying with legal obligations</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">4. Email Validation</h2>
          <p>
            To ensure the integrity of our voting system, we validate email addresses provided during 
            registration. This validation may include:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Verifying the format of the email address</li>
            <li>Checking if the email domain exists</li>
            <li>Identifying and blocking disposable email addresses</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">5. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to enhance your experience on our platform. 
            These technologies help us understand how you interact with our site and allow us to remember 
            your preferences.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">6. Third-Party Services</h2>
          <p>
            We may use third-party services, such as Cloudflare Turnstile, to protect our platform from 
            spam and abuse. These services may collect information about your device and browsing patterns 
            to distinguish between human users and bots.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">7. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information. However, 
            no method of transmission over the Internet or electronic storage is 100% secure, and we 
            cannot guarantee absolute security.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">8. Your Rights</h2>
          <p>
            Depending on your location, you may have certain rights regarding your personal information, 
            including the right to:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your information</li>
            <li>Object to or restrict certain processing activities</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">9. Children's Privacy</h2>
          <p>
            Our platform is not intended for children under 13 years of age. We do not knowingly collect 
            personal information from children under 13.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">10. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by 
            posting the new Privacy Policy on this page.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">11. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at privacy@toonhouse.com.
          </p>
        </div>
        
        <div className="mt-8 text-center">
          <button 
            onClick={onBack}
            className="bg-gray-800 text-white py-3 px-6 rounded-md font-semibold hover:bg-gray-900 transition-colors"
          >
            Back to Voting
          </button>
        </div>
      </div>
    </div>
    </div>
  );
};

export default PrivacyPolicy;
